{
  "common": {
    "buttons": {
      "save": "Opslaan",
      "cancel": "Annuleren",
      "delete": "Verwijderen",
      "submit": "Verzenden",
      "back": "Terug",
      "edit": "Bewerken",
      "login": "Inloggen",
      "register": "Registreren",
      "createAccount": "Account aanmaken",
      "backToLogin": "Terug naar inloggen",
      "logout": "Uitloggen",
      "create": "Aanmaken",
      "refresh": "Vernieuwen"
    },
    "labels": {
      "email": "E-mail",
      "password": "Wachtwoord"
    },
    "success": "Succes",
    "errors": {
      "title": "Fout",
      "error": "Fout",
      "network": "Netwerkfout opgetreden",
      "unknown": "Er is een onverwachte fout opgetreden",
      "loadFailed": "Gegevens laden mislukt",
      "operationFailed": "Bewerking mislukt. Probeer het opnieuw.",
      "sessionExpired": "Sessie Verlopen",
      "sessionExpiredMessage": "Uw sessie is verlopen. Log opnieuw in om door te gaan.",
      "authenticationRequired": "Authenticatie Vereist",
      "authenticationRequiredMessage": "Uw sessie is verlopen. Log opnieuw in.",
      "accessDenied": "Toegang Geweigerd",
      "accessDeniedMessage": "U heeft geen toestemming om deze actie uit te voeren.",
      "serviceUnavailable": "Service Niet Beschikbaar",
      "serviceUnavailableMessage": "De service is tijdelijk niet beschikbaar. Probeer het later opnieuw.",
      "connectionError": "Verbindingsfout",
      "checkConnection": "Controleer uw internetverbinding en probeer het opnieuw.",
      "unauthorized": "Niet Geautoriseerd",
      "loginFailed": "Inloggen mislukt. Probeer het opnieuw."
    },
    "validation": {
      "allFieldsRequired": "Vul alle velden in",
      "emailRequired": "E-mail is verplicht",
      "emailInvalid": "Voer een geldig e-mailadres in",
      "passwordRequired": "Wachtwoord is verplicht",
      "passwordMinLength": "Wachtwoord moet minimaal 6 tekens bevatten",
      "passwordMismatch": "Wachtwoorden komen niet overeen",
      "nameRequired": "Naam is verplicht",
      "firstNameRequired": "Voornaam is verplicht",
      "lastNameRequired": "Achternaam is verplicht",
      "titleRequired": "Titel is verplicht",
      "descriptionRequired": "Beschrijving is verplicht",
      "priceRequired": "Prijs is verplicht",
      "priceInvalid": "Prijs moet een geldig nummer zijn",
      "sizeRequired": "Maat is verplicht",
      "categoryRequired": "Categorie is verplicht",
      "conditionRequired": "Conditie is verplicht",
      "clubRequired": "Club is verplicht",
      "invalidCredentials": "Ongeldig e-mailadres of wachtwoord",
      "emailNotConfirmed": "Verifieer uw e-mailadres voordat u inlogt",
      "emailAlreadyExists": "Dit e-mailadres is al geregistreerd",
      "maxImagesReached": "Maximaal 2 afbeeldingen toegestaan",
      "uploadFailed": "Upload mislukt. Probeer het opnieuw.",
      "rateLimitReached": "Te veel uploads. Wacht even.",
      "invalidImageType": "Alleen JPEG, PNG en WebP worden ondersteund",
      "imageTooLarge": "Afbeelding te groot. Maximaal 10MB.",
      "permissionDenied": "Toegang tot mediagalerij geweigerd"
    },
    "loading": "Laden...",
    "loadingMore": "Meer laden...",
    "noData": "Geen gegevens beschikbaar",
    "optional": "(optioneel)",
    "refresh": "Vernieuwen",
    "select": "Selecteer",
    "search": "Zoeken",
    "noResults": "Geen resultaten gevonden",
    "relativeTime": {
      "justNow": "Zojuist",
      "minutesAgo_one": "{{count}} minuut geleden",
      "minutesAgo_other": "{{count}} minuten geleden",
      "hoursAgo_one": "{{count}} uur geleden",
      "hoursAgo_other": "{{count}} uur geleden",
      "yesterday": "Gisteren",
      "daysAgo_one": "{{count}} dag geleden",
      "daysAgo_other": "{{count}} dagen geleden",
      "lastWeek": "Vorige week"
    }
  },
  "auth": {
    "reauth": {
      "title": "Sessie Verlopen",
      "message": "Uw sessie is verlopen. Log opnieuw in om door te gaan.",
      "submit": "Inloggen"
    }
  },
  "enums": {
    "category": {
      "jersey": "Shirt",
      "shorts": "Broek",
      "socks": "Sokken",
      "jacket": "Jas",
      "other": "Overig"
    },
    "condition": {
      "new": "Nieuw",
      "like-new": "Als nieuw",
      "good": "Goed",
      "fair": "Redelijk"
    },
    "status": {
      "available": "Beschikbaar",
      "reserved": "Gereserveerd",
      "sold": "Verkocht"
    },
    "clubRole": {
      "member": "Lid",
      "manager": "Beheerder"
    }
  },
  "screens": {
    "login": {
      "title": "Clubswap",
      "subtitle": "Sportclub Marktplaats",
      "email": "E-mail",
      "emailPlaceholder": "Voer uw e-mailadres in",
      "password": "Wachtwoord",
      "passwordPlaceholder": "Voer uw wachtwoord in",
      "loginFailed": "Inloggen mislukt",
      "forgotPassword": "Wachtwoord vergeten?"
    },
    "register": {
      "title": "Account aanmaken",
      "subtitle": "Word lid van de marktplaats van je club — koop en verkoop te klein geworden kleding met mensen die je al kent.",
      "firstName": "Voornaam",
      "firstNamePlaceholder": "Voer uw voornaam in",
      "lastName": "Achternaam",
      "lastNamePlaceholder": "Voer uw achternaam in",
      "preferredLanguage": "Voorkeurstaal",
      "selectClubs": "Selecteer uw Clubs (Optioneel)",
      "selectClubsHint": "U kunt later clubs toevoegen",
      "name": "Naam",
      "namePlaceholder": "Voer uw naam in",
      "email": "E-mail",
      "emailPlaceholder": "Voer uw e-mailadres in",
      "password": "Wachtwoord",
      "passwordPlaceholder": "Voer uw wachtwoord in",
      "confirmPassword": "Bevestig Wachtwoord",
      "confirmPasswordPlaceholder": "Bevestig uw wachtwoord",
      "success": "Succes",
      "successMessage": "Account aangemaakt! Controleer uw e-mail om uw account te verifiëren.",
      "registrationFailed": "Registratie mislukt"
    },
    "forgotPassword": {
      "title": "Wachtwoord resetten",
      "subtitle": "Voer uw e-mailadres in en we sturen u een resetlink",
      "emailPlaceholder": "Voer uw e-mailadres in",
      "sendResetLink": "Verstuur resetlink",
      "successTitle": "Controleer je e-mail",
      "successMessage": "We hebben een wachtwoord-resetlink naar uw e-mail gestuurd. Controleer uw inbox.",
      "failed": "Resetlink versturen mislukt"
    },
    "resetPassword": {
      "title": "Nieuw wachtwoord instellen",
      "subtitle": "Voer hieronder uw nieuwe wachtwoord in",
      "newPassword": "Nieuw Wachtwoord",
      "newPasswordPlaceholder": "Voer nieuw wachtwoord in",
      "confirmPassword": "Bevestig Wachtwoord",
      "confirmPasswordPlaceholder": "Bevestig nieuw wachtwoord",
      "submit": "Wachtwoord bijwerken",
      "successTitle": "Wachtwoord gereset",
      "successMessage": "Uw wachtwoord is succesvol gereset.",
      "failed": "Wachtwoord resetten mislukt",
      "invalidSession": "Ongeldige of verlopen resetlink. Vraag een nieuwe aan."
    },
    "changePassword": {
      "title": "Wachtwoord wijzigen",
      "currentPassword": "Huidig wachtwoord",
      "currentPasswordPlaceholder": "Voer huidig wachtwoord in",
      "newPassword": "Nieuw wachtwoord",
      "newPasswordPlaceholder": "Voer nieuw wachtwoord in",
      "confirmPassword": "Bevestig nieuw wachtwoord",
      "confirmPasswordPlaceholder": "Bevestig nieuw wachtwoord",
      "submit": "Opslaan",
      "successTitle": "Wachtwoord gewijzigd",
      "successMessage": "Uw wachtwoord is succesvol gewijzigd.",
      "failed": "Wachtwoord wijzigen mislukt",
      "incorrectCurrentPassword": "Huidig wachtwoord is onjuist"
    },
    "home": {
      "title": "Clubswap",
      "recentFromClubs": "Recent van jouw clubs",
      "myListings": "Mijn advertenties",
      "recentlyListedOverall": "Recent Algemeen",
      "viewAll": "Bekijk alles",
      "browseAll": "Bekijk Aanbod →",
      "viewMyListings": "Bekijk alles",
      "noClubItems": "Nog niets aangeboden",
      "noClubItemsSubtext": "Wees de eerste — plaats een kledingstuk voor je club.",
      "noItems": "Geen items beschikbaar",
      "noItemsSubtext": "Wees de eerste om een item toe te voegen!",
      "noMyListings": "Onlangs iets verkocht?",
      "noMyListingsSubtext": "Te klein geworden kleding vindt binnen een paar dagen een nieuwe eigenaar bij je club.",
      "addFirstItem": "Advertentie plaatsen",
      "loadError": "Home-gegevens laden mislukt"
    },
    "browse": {
      "title": "Aanbod",
      "searchPlaceholder": "Zoek uitrusting…",
      "filterByClub": "Filter op club",
      "allClubs": "Alle clubs",
      "categoryAll": "Alles",
      "noResults": "Geen items gevonden",
      "noResultsSubtext": "Probeer uw zoekopdracht of filters aan te passen",
      "itemCount_one": "{{count}} item",
      "itemCount_other": "{{count}} items",
      "inClub": "in {{club}}",
      "sortNewest": "Nieuwste eerst",
      "sortPriceAsc": "Prijs: laag naar hoog",
      "loadError": "Items laden mislukt"
    },
    "itemDetails": {
      "deleteConfirm": "Advertentie verwijderen",
      "deleteConfirmMessage": "Weet u zeker dat u dit item wilt verwijderen?",
      "editItem": "Advertentie bewerken",
      "price": "Prijs",
      "size": "Maat",
      "condition": "Conditie",
      "category": "Categorie",
      "club": "Club",
      "seller": "Verkoper",
      "description": "Beschrijving",
      "noDescription": "Geen beschrijving opgegeven",
      "deleteFailed": "Item verwijderen mislukt",
      "cannotDeleteTransaction": "Kan niet verwijderen - transactie in behandeling",
      "loadFailed": "Item details laden mislukt",
      "contactSellerMessage": "U kunt contact opnemen met de verkoper via e-mail om de aankoop te regelen.",
      "itemMarkedReserved": "Item gemarkeerd als gereserveerd",
      "itemMarkedSold": "Item gemarkeerd als verkocht",
      "itemDeleted": "Item verwijderd",
      "updateStatusFailed": "Item status bijwerken mislukt",
      "markAsReserved": "Markeer als Gereserveerd",
      "markAsSold": "Markeer als verkocht",
      "contactSeller": "Contact met verkoper",
      "reportItem": "Melden",
      "viewCount_one": "Bekeken door {{count}} persoon",
      "viewCount_other": "Bekeken door {{count}} personen",
      "reportSuccess": "Bedankt voor uw melding. We zullen deze binnenkort bekijken.",
      "reportFailed": "Melding indienen mislukt. Probeer het opnieuw.",
      "alreadyReported": "U heeft dit item al gemeld.",
      "reportingItem": "Item melden",
      "selectReason": "Selecteer een reden voor melding",
      "additionalDetails": "Aanvullende details",
      "detailsPlaceholder": "Geef meer informatie over waarom u dit item meldt...",
      "reportReasons": {
        "inappropriate": "Ongepaste of beledigende inhoud",
        "scam": "Vermoedelijke oplichting of frauduleuze advertentie",
        "copyright": "Auteursrecht of merkenschending",
        "other": "Andere reden"
      },
      "startConversation": "Contact met verkoper",
      "inConversation": "Open chat",
      "conversationExists": "Je hebt al een gesprek over dit item",
      "startConversationFailed": "Kan gesprek niet starten. Probeer het opnieuw.",
      "markSoldCta": "Markeer als verkocht",
      "listed": "Geplaatst {{when}}",
      "memberOf": "Lid van {{club}}",
      "title": "Advertentie"
    },
    "markAsSold": {
      "title": "Verkocht aan",
      "intro": "Aan wie heb je \"{{itemTitle}}\" verkocht?",
      "askingPrice": "Vraagprijs {{price}}",
      "buyerLabel": "Koper",
      "buyerPlaceholder": "Kies een koper",
      "someoneElse": "Iemand anders",
      "buyerNameLabel": "Naam koper (optioneel)",
      "buyerNamePlaceholder": "Bijv. naam of omschrijving",
      "priceLabel": "Verkoopprijs (optioneel)",
      "pricePlaceholder": "Bijv. 12,50",
      "priceHint": "Standaard je vraagprijs. Pas aan als je voor een ander bedrag hebt verkocht, of laat leeg.",
      "noConversations": "Er zijn nog geen gesprekken over dit item. Kies \"Iemand anders\" als je het buiten Clubswap hebt verkocht.",
      "confirmButton": "Bevestig verkoop",
      "confirmTitle": "Verkoop bevestigen",
      "confirmMessage": "Weet je zeker dat je dit item als verkocht wilt markeren? De advertentie gaat dan offline.",
      "selectBuyerError": "Kies een koper of \"Iemand anders\"",
      "success": "De verkoop is geregistreerd en je advertentie is offline gehaald.",
      "failed": "Verkoop registreren mislukt. Probeer het opnieuw.",
      "loadFailed": "Kan gegevens niet laden",
      "notAllowed": "Alleen de verkoper kan dit item als verkocht markeren.",
      "invalidPrice": "Vul een geldig bedrag in, of laat het veld leeg.",
      "alreadySold": "Dit item staat al als verkocht geregistreerd.",
      "buyerNotInConversation": "Deze koper heeft geen gesprek over dit item. Kies \"Iemand anders\".",
      "notAuthenticated": "Je bent niet meer ingelogd. Log opnieuw in en probeer het nog eens."
    },
    "conversations": {
      "title": "Berichten",
      "noConversations": "Nog geen gesprekken",
      "noConversationsSubtext": "Start een gesprek met een verkoper om items te kopen.",
      "loadError": "Kan gesprekken niet laden",
      "seller": "Verkoper",
      "buyer": "Koper",
      "noMessages": "Nog geen berichten",
      "justNow": "Zojuist",
      "minutesAgo_one": "{{count}} minuut geleden",
      "minutesAgo_other": "{{count}} minuten geleden",
      "hoursAgo_one": "{{count}} uur geleden",
      "hoursAgo_other": "{{count}} uur geleden",
      "daysAgo_one": "{{count}} dag geleden",
      "daysAgo_other": "{{count}} dagen geleden",
      "count_one": "{{count}} gesprek",
      "count_other": "{{count}} gesprekken",
      "itemDeleted": "Item verwijderd"
    },
    "chat": {
      "title": "Chat",
      "loadConversationError": "Kan gesprek niet laden",
      "loadMessagesError": "Kan berichten niet laden",
      "sendMessageError": "Kan bericht niet verzenden",
      "noMessages": "Nog geen berichten",
      "noMessagesSubtext": "Begin het gesprek door een bericht te sturen",
      "unknownMember": "Clublid",
      "conversationWith": "Gesprek met",
      "typePlaceholder": "Type een bericht...",
      "send": "Verstuur",
      "viewItem": "Bekijk item",
      "itemDeleted": "Item is verwijderd",
      "closeEmptyChatTitle": "Gesprek sluiten?",
      "closeEmptyChatMessage": "Je hebt nog geen berichten verstuurd. Als je deze chat sluit, wordt het gesprek verwijderd en kunnen andere kopers opnieuw een gesprek starten voor dit item.",
      "reserved": "Gereserveerd"
    },
    "privacy": {
      "title": "Privacy",
      "intro": "Clubswap brengt leden van sportclubs samen om tweedehands kinderkleding en -materiaal te kopen en verkopen. Deze pagina legt in gewone taal uit welke gegevens we verwerken.",
      "dataTitle": "Wat we bewaren",
      "dataBody": "Je accountgegevens (naam, e-mail, de clubs waar je lid van wordt) en de advertenties en berichten die je plaatst. We gebruiken dit alleen om de marktplaats te laten werken — om advertenties te tonen, chats mogelijk te maken en je een deal te laten afspreken.",
      "paymentsTitle": "Betalingen",
      "paymentsBody": "In de opstartfase loopt er geen geld via Clubswap. Koper en verkoper spreken een prijs af in de app en rekenen onderling af op de club. We verwerken geen betalingen en bewaren geen bankgegevens.",
      "statsTitle": "Gebruiksstatistieken",
      "statsBody": "We houden geanonimiseerde, geaggregeerde statistieken bij over hoe het platform wordt gebruikt (zoals het aantal advertenties, weergaven, chats en afgeronde deals) om de dienst te begrijpen en te verbeteren. Deze geaggregeerde statistieken bevatten geen persoonsgegevens en kunnen worden gedeeld met clubs, sportbonden en partners om te laten zien hoe het platform presteert.",
      "rightsTitle": "Jouw rechten",
      "rightsBody": "Je kunt je profiel altijd aanpassen en je account verwijderen via Instellingen, waarmee je persoonsgegevens worden verwijderd. Vragen over je gegevens? Mail ons op privacy@clubswap.nl."
    },
    "profile": {
      "title": "Profiel",
      "myListings": "Mijn advertenties",
      "myClubs": "Mijn clubs",
      "settings": "Instellingen",
      "languageSection": "Taal",
      "memberSince": "Lid sinds",
      "notSet": "Niet ingesteld",
      "addListing": "Toevoegen",
      "adminDashboard": "Beheerderspaneel",
      "logoutConfirmMessage": "Weet je zeker dat je wilt uitloggen? Je moet dan opnieuw inloggen om bij je account te kunnen.",
      "noListings": "Ruimte voor nog één",
      "noListingsSubtext": "Te klein maar nog goed — iemand bij je club heeft het nodig.",
      "noClubs": "Nog geen clubs",
      "noClubsSubtext": "Word lid van een club om deze hier te zien",
      "viewClub": "Bekijk club",
      "loadError": "Profielgegevens laden mislukt",
      "changePassword": "Wachtwoord wijzigen",
      "dangerZone": "Gevarenzone",
      "setupProfile": "Stel je profiel in",
      "editProfile": "Profiel bewerken",
      "editProfileTitle": "Profiel bewerken",
      "firstName": "Voornaam",
      "lastName": "Achternaam",
      "firstNameRequired": "Voornaam is verplicht",
      "lastNameRequired": "Achternaam is verplicht",
      "firstNameTooLong": "Voornaam mag maximaal 50 tekens bevatten",
      "lastNameTooLong": "Achternaam mag maximaal 50 tekens bevatten",
      "profileUpdated": "Profiel bijgewerkt",
      "profileUpdateFailed": "Profiel bijwerken mislukt",
      "changeAvatar": "Foto wijzigen",
      "edit": "Bewerken",
      "statListings": "advertenties",
      "statSold": "verkocht",
      "statClubs": "clubs"
    },
    "adminDashboard": {
      "title": "Beheerderspaneel",
      "subtitle": "Platformbeheer",
      "manageUsers": "Gebruikers Beheren",
      "manageUsersDescription": "Promoveer admins en clubmanagers",
      "manageClubs": "Clubs Beheren",
      "manageClubsDescription": "Clubs aanmaken en verwijderen",
      "notAuthorized": "Je bent niet gemachtigd om deze pagina te openen",
      "manageOptionsDescription": "Beheer categorieën, condities, maten en sporttypes",
      "analytics": "Analyse",
      "analyticsDescription": "Gebruikers, advertenties, transacties, retentie en moderatie"
    },
    "adminAnalytics": {
      "title": "Analyse",
      "users": "Gebruikers",
      "totalRegistered": "Totaal geregistreerd",
      "new": "Nieuw",
      "active": "Actief",
      "last7days": "afgelopen 7 dagen",
      "last30days": "afgelopen 30 dagen",
      "onboardingCompleted": "Onboarding afgerond",
      "listings": "Advertenties",
      "total": "Totaal",
      "available": "Beschikbaar",
      "reserved": "Gereserveerd",
      "sold": "Verkocht",
      "new7d": "Nieuw (7d)",
      "new30d": "Nieuw (30d)",
      "averagePrice": "Gemiddelde prijs",
      "topCategories": "Top categorieën",
      "transactions": "Transacties & betalingen",
      "pending": "Openstaand (pending)",
      "paid": "Betaald",
      "completed": "Voltooid",
      "disputed": "In dispute",
      "cancelled": "Geannuleerd",
      "avgTransactionValue": "Gem. transactiewaarde",
      "clubs": "Clubs",
      "activeClubs": "Actieve clubs",
      "topByMembers": "Top 5 — meeste leden",
      "topByListings": "Top 5 — meeste advertenties",
      "members": "leden",
      "ads": "ads",
      "engagement": "Engagement & retentie",
      "conversionRate": "Conversieratio",
      "conversionRateSub": "advertenties die daadwerkelijk verkocht zijn",
      "messages7d": "Berichten (7d)",
      "messages30d": "Berichten (30d)",
      "avgMessagesPerDay": "Gem. berichten/dag (30d)",
      "retentionSeller": "Retentie: verkoper",
      "retentionSellerSub": "gebruikers die ≥1 advertentie hebben geplaatst",
      "retentionBuyer": "Retentie: koper",
      "retentionBuyerSub": "gebruikers die ≥1 aankoop hebben gedaan",
      "moderation": "Moderatie",
      "openReports": "Openstaande meldingen",
      "openReportsSub": "items met melding, nog niet afgehandeld",
      "totalHandled": "Totaal afgehandeld",
      "approved": "Goedgekeurd",
      "deleted": "Verwijderd",
      "avgResolutionTime": "Gem. afdoeningstijd",
      "avgResolutionTimeSub": "tijd tussen eerste melding en actie",
      "hours": "uur",
      "kpiUsers": "Gebruikers",
      "kpiListings": "Advertenties",
      "kpiTransactions": "Transacties",
      "kpiGmv30d": "GMV (30d)",
      "kpiGmv": "GMV (totaal)",
      "copyReport": "Kopieer deelbaar rapport",
      "reportCopied": "Rapport gekopieerd naar klembord",
      "funnel": "Funnel",
      "funnelListings": "Advertenties",
      "funnelViewed": "Bekeken (≥1 weergave)",
      "funnelChats": "Chats gestart",
      "funnelDeals": "Verkocht",
      "ofPrevious": "{{pct}} van vorige stap",
      "traction": "Tractie",
      "gmvTotal": "GMV (totaal)",
      "gmvSub": "som van de opgegeven verkoopprijzen",
      "gmv30d": "GMV (laatste 30 dagen)",
      "gmvCoverage": "Prijs bekend bij",
      "gmvCoverageSub": "verkopen mét prijs — GMV is een ondergrens",
      "dealsOnPlatform": "Verkocht via het platform",
      "dealsOnPlatformSub": "koper kwam uit een gesprek op Clubswap",
      "dealsOffPlatform": "Verkocht buiten het platform",
      "medianDaysToSale": "Mediane tijd tot verkoop",
      "days": "dagen",
      "pctSoldWithin30d": "Verkocht binnen 30 dagen",
      "pctSoldWithin30dSub": "van advertenties ouder dan 30 dagen",
      "repeatSellers": "Herhaalverkopers (≥2 verkopen)",
      "repeatBuyers": "Herhaalkopers (≥2 aankopen)",
      "weeklyTitle": "Per week (laatste 12 weken)",
      "weekCol": "Week",
      "signupsCol": "Aanmeldingen",
      "listingsCol": "Advertenties",
      "dealsCol": "Verkopen",
      "chattersCol": "Actief",
      "kpiOpenReports": "Meldingen open"
    },
    "adminSettings": {
      "title": "Platforminstellingen",
      "subtitle": "Platformbrede instellingen configureren",
      "dashboardDescription": "Platformkosten en instellingen configureren",
      "clubswapFeeTitle": "Clubswap Platformkosten",
      "clubswapFeeDescription": "Vaste kosten per transactie ter ondersteuning van platformactiviteiten",
      "feeAmount": "Kostenbedrag",
      "currentFee": "Huidige Kosten",
      "feeRangeHint": "Bereik: €{{min}} - €{{max}}",
      "errorFeeRequired": "Kostenbedrag is verplicht",
      "errorInvalidFee": "Voer een geldig kostenbedrag in",
      "errorFeeRange": "Kosten moeten tussen €{{min}} en €{{max}} liggen",
      "successSave": "Instellingen succesvol opgeslagen",
      "payoutScheduleTitle": "Uitbetalingsschema verkopers (Stripe)",
      "payoutScheduleHelper": "Geldt alleen voor verkopers die zich hierna aanmelden; bestaande accounts houden hun huidige schema.",
      "payoutScheduleDefault": "Stripe-standaard — doorlopend, meestal binnen enkele werkdagen",
      "payoutScheduleWeekly": "Wekelijks — gebundeld, lagere kosten per uitbetaling",
      "payoutScheduleMonthly": "Maandelijks — laagste kosten, verkoper wacht het langst"
    },
    "manageUsers": {
      "title": "Gebruikers Beheren",
      "noUsers": "Geen gebruikers gevonden",
      "searchPlaceholder": "Zoek op naam, e-mail of club",
      "noSearchResults": "Geen gebruikers gevonden met uw zoekopdracht",
      "promoteAdmin": "Promoveer tot Admin",
      "demoteAdmin": "Degradeer van Admin",
      "manageClubRole": "Clubrol Beheren",
      "confirmPromoteAdmin": "Deze gebruiker promoveren tot platformbeheerder?",
      "confirmDemoteAdmin": "Beheerdersrechten verwijderen van deze gebruiker?",
      "cannotDemoteSelf": "Je kunt jezelf niet degraderen",
      "successPromoteAdmin": "Gebruiker gepromoveerd tot admin",
      "successDemoteAdmin": "Gebruiker gedegradeerd van admin",
      "successPromoteManager": "Gebruiker gepromoveerd tot clubmanager",
      "successDemoteManager": "Gebruiker verwijderd als clubmanager",
      "deleteUser": "Account Verwijderen",
      "deleteModalTitle": "Account verwijderen",
      "deleteModalSubtitle": "Account van $t(name) markeren voor verwijdering.",
      "deleteModalInfo": "Dit is een soft-delete. De gebruiker wordt direct geblokkeerd en het account wordt na 30 dagen definitief verwijderd. De opgegeven reden wordt permanent bewaard.",
      "reasonLabel": "Reden (verplicht)",
      "reasonPlaceholder": "Geef een reden op voor de verwijdering...",
      "deleteConfirm": "Verwijder account",
      "deleteSuccess": "Account gemarkeerd voor verwijdering",
      "deleteSuccessMessage": "Het account van {{name}} wordt over 30 dagen definitief verwijderd.",
      "scheduledForDeletion": "Gepland voor verwijdering",
      "deletionReason": "Reden"
    },
    "manageClubs": {
      "title": "Clubs Beheren",
      "createClub": "Nieuwe Club Aanmaken",
      "editClub": "Club Bewerken",
      "edit": "Bewerken",
      "delete": "Verwijderen",
      "clubName": "Clubnaam",
      "clubDescription": "Beschrijving (optioneel)",
      "location": "Locatie",
      "locationPlaceholder": "bijv. Amsterdam, Rotterdam",
      "isVerified": "Geverifieerde Club",
      "adminOnly": "Alleen Admin",
      "transactionFee": "Clubbijdrage",
      "feeRange": "Bereik: €{{min}} - €{{max}}",
      "feeLabel": "Clubbijdrage (€)",
      "feePlaceholder": "1.00",
      "feeHelp": "Bedrag dat de club ontvangt per transactie",
      "errorFeeOutOfRange": "Clubbijdrage moet tussen €{{min}} en €{{max}} liggen",
      "errorNameRequired": "Clubnaam is verplicht",
      "errorNameTooShort": "Clubnaam moet minimaal 2 tekens zijn",
      "errorDuplicateName": "Een club met deze naam bestaat al",
      "successCreate": "Club succesvol aangemaakt",
      "successUpdate": "Club succesvol bijgewerkt",
      "successDelete": "Club succesvol verwijderd",
      "confirmDelete": "Weet je zeker dat je deze club wilt verwijderen?",
      "searchPlaceholder": "Zoek op clubnaam of beschrijving",
      "noClubs": "Geen clubs gevonden",
      "noSearchResults": "Geen clubs gevonden met uw zoekopdracht"
    },
    "addListing": {
      "title": "Advertentie toevoegen",
      "itemDetails": "Itemdetails",
      "titleLabel": "Titel",
      "titlePlaceholder": "bijv., FC Barcelona Thuisshirt",
      "description": "Beschrijving",
      "descriptionPlaceholder": "Beschrijf de staat van het item, maat, etc.",
      "price": "Prijs",
      "pricePlaceholder": "0.00",
      "size": "Maat",
      "sizePlaceholder": "bijv., M, L, XL",
      "category": "Categorie",
      "selectCategory": "Selecteer categorie",
      "condition": "Conditie",
      "selectCondition": "Selecteer conditie",
      "sportType": "Sporttype",
      "sportTypePlaceholder": "Selecteer sporttype (optioneel)",
      "club": "Club",
      "selectClub": "Selecteer club",
      "noClub": "Geen club",
      "createListing": "Advertentie plaatsen",
      "success": "Succes",
      "successMessage": "Advertentie succesvol aangemaakt!",
      "createFailed": "Advertentie aanmaken mislukt",
      "draftFound": "Concept gevonden",
      "draftFoundMessage": "U heeft een opgeslagen concept van uw vorige sessie. Wilt u dit herstellen?",
      "draftRestored": "Concept hersteld",
      "draftRestoredMessage": "Uw vorige advertentie is hersteld.",
      "draftSaved": "Concept opgeslagen",
      "draftIndicator": "Concept automatisch opgeslagen",
      "form": {
        "club": {
          "label": "Plaatsen in club",
          "placeholder": "Selecteer een club"
        }
      },
      "validation": {
        "selectClub": {
          "title": "Selecteer club",
          "message": "Selecteer een club om dit item in te plaatsen."
        }
      },
      "minimumPriceHint": "Minimumprijs: €{{minimum}}",
      "priceTooLow": "Prijs moet minimaal €{{minimum}} zijn om club- en servicekosten te dekken"
    },
    "itemForm": {
      "title": "Advertentie toevoegen",
      "editTitle": "Advertentie bewerken",
      "itemDetails": "Itemdetails",
      "titleLabel": "Titel",
      "titlePlaceholder": "bijv., FC Barcelona Thuisshirt",
      "description": "Beschrijving",
      "descriptionPlaceholder": "Beschrijf de staat van het item, maat, etc.",
      "price": "Prijs",
      "pricePlaceholder": "0.00",
      "size": "Maat",
      "sizePlaceholder": "bijv., M, L, XL",
      "category": "Categorie",
      "selectCategory": "Selecteer categorie",
      "condition": "Conditie",
      "selectCondition": "Selecteer conditie",
      "sportType": "Sporttype",
      "sportTypePlaceholder": "Selecteer sporttype (optioneel)",
      "club": "Club",
      "selectClub": "Selecteer club",
      "noClub": "Geen club",
      "createListing": "Advertentie plaatsen",
      "saveChanges": "Wijzigingen opslaan",
      "success": "Succes",
      "successMessage": "Advertentie succesvol aangemaakt!",
      "updateSuccess": "Bijgewerkt",
      "updateSuccessMessage": "Je item is bijgewerkt!",
      "createFailed": "Advertentie aanmaken mislukt",
      "itemNotFound": "Item niet gevonden",
      "notOwner": "Je kunt alleen je eigen items bewerken",
      "cannotEditStatus": "Je kunt alleen beschikbare items bewerken",
      "draftFound": "Concept gevonden",
      "draftFoundMessage": "U heeft een opgeslagen concept van uw vorige sessie. Wilt u dit herstellen?",
      "draftRestored": "Concept hersteld",
      "draftRestoredMessage": "Uw vorige advertentie is hersteld.",
      "draftSaved": "Concept opgeslagen",
      "draftIndicator": "Concept automatisch opgeslagen",
      "form": {
        "club": {
          "label": "Plaatsen in club",
          "placeholder": "Selecteer een club"
        }
      },
      "validation": {
        "selectClub": {
          "title": "Selecteer club",
          "message": "Selecteer een club om dit item in te plaatsen."
        }
      },
      "minimumPriceHint": "Minimumprijs: €{{minimum}}",
      "priceTooLow": "Prijs moet minimaal €{{minimum}} zijn om club- en servicekosten te dekken",
      "subtitle": "Goede foto’s en een eerlijke omschrijving verkopen het snelst."
    },
    "clubs": {
      "title": "Clubs",
      "searchPlaceholder": "Zoek een club…",
      "noResults": "Geen clubs gevonden",
      "noResultsSubtext": "Probeer een andere zoekterm",
      "noSearchResults": "Geen clubs gevonden",
      "noSearchResultsSubtext": "Probeer een andere zoekterm",
      "memberCount_one": "{{count}} lid",
      "memberCount_other": "{{count}} leden",
      "loadError": "Clubs laden mislukt",
      "tapToViewDetails": "Tik om details te bekijken",
      "myClubs": "Mijn clubs",
      "otherClubs": "Meer clubs",
      "count_one": "{{count}} club",
      "count_other": "{{count}} clubs",
      "ranking": "Ranglijst",
      "noClubsJoined": "Je bent nog geen lid van een club",
      "noClubsJoinedSubtext": "Word lid van een club om het aanbod op Home te zien.",
      "subtitle": "Word lid van de clubs waar je bij hoort — je ziet hun aanbod op Home en kunt zelf advertenties plaatsen."
    },
    "clubDetail": {
      "title": "Clubdetails",
      "editClub": "Club bewerken",
      "joinClub": "Word lid",
      "leaveClub": "Club verlaten",
      "members": "Leden",
      "recentListings": "Recente advertenties",
      "viewAllListings": "Bekijk alles",
      "noListings": "Nog niets aangeboden",
      "noListingsSubtext": "Wees de eerste — plaats een kledingstuk voor deze club.",
      "joined": "Lid Geworden",
      "joinSuccess": "Succesvol lid geworden van de club!",
      "leaveSuccess": "Succesvol de club verlaten!",
      "joinFailed": "Lid worden mislukt",
      "leaveFailed": "Club verlaten mislukt",
      "notAuthenticated": "U moet ingelogd zijn om lid te worden van een club",
      "clubNotFound": "Club niet gevonden",
      "clubNotFoundMessage": "Club niet gevonden",
      "loadError": "Club details laden mislukt",
      "logoUpdated": "Club logo succesvol bijgewerkt",
      "logoUpdateFailed": "Club logo bijwerken mislukt",
      "listings": "Advertenties",
      "managers": "Beheerders",
      "verified": "Geverifieerd",
      "leaveConfirmTitle": "{{club}} verlaten?",
      "leaveConfirmMessage": "Je ziet dan geen advertenties van deze club meer. Je kunt altijd opnieuw lid worden."
    },
    "onboarding": {
      "loading": "Laden...",
      "welcome": {
        "title": "Welkom bij Clubswap!",
        "subtitle": "De marktplaats voor sportuitrusting van jouw club",
        "feature1Title": "Kopen & Verkopen",
        "feature1Description": "Ruil sportuitrusting binnen jouw clubgemeenschap",
        "feature2Title": "Clubgericht",
        "feature2Description": "Maak contact met leden van jouw sportclubs",
        "feature3Title": "Bespaar geld",
        "feature3Description": "Vind betaalbare uitrusting en geef items een tweede leven",
        "getStarted": "Aan de slag"
      },
      "clubSelection": {
        "title": "Word lid van je clubs",
        "subtitle": "Selecteer de clubs waar je lid van bent om relevante advertenties te zien",
        "searchPlaceholder": "Zoek clubs...",
        "counter": "{{count}} club geselecteerd (max {{max}})",
        "counter_plural": "{{count}} clubs geselecteerd (max {{max}})",
        "noClubsFound": "Geen clubs gevonden",
        "verifiedBadge": "✓ Geverifieerd",
        "backButton": "← Terug",
        "skipButton": "Overslaan",
        "continueButton": "Doorgaan"
      },
      "completion": {
        "title": "Alles Klaar!",
        "subtitleWithClubs": "Je bent lid geworden van {{count}} club",
        "subtitleWithClubs_plural": "Je bent lid geworden van {{count}} clubs",
        "subtitleNoClubs": "Je kunt altijd clubs toevoegen vanuit de clubs pagina",
        "whatsNext": "Wat Nu?",
        "step1": "Bekijk advertenties van jouw Clubs",
        "step2": "Plaats items die je wilt verkopen",
        "step3": "Maak contact met clubleden",
        "backButton": "← Terug",
        "finishButton": "Naar Clubswap",
        "finishing": "Afronden..."
      },
      "errors": {
        "loadClubsFailed": "Clubs laden mislukt. Probeer het opnieuw.",
        "maxClubsReached": "Maximum bereikt",
        "maxClubsMessage": "Je kunt lid worden van maximaal {{max}} clubs.",
        "completeFailed": "Onboarding afronden mislukt. Probeer het opnieuw."
      }
    },
    "adminListings": {
      "title": "Alle Advertenties",
      "dashboardDescription": "Bekijk en verwijder advertenties ongeacht status",
      "subtitle": "{{count}} advertenties",
      "searchPlaceholder": "Zoek op titel...",
      "deleteTitle": "Advertentie verwijderen",
      "deleteMessage": "Weet je zeker dat je \"{{title}}\" wilt verwijderen? Dit kan niet ongedaan worden gemaakt.",
      "empty": "Geen advertenties gevonden",
      "noResponses": "Nog geen reacties",
      "engagementUnavailable": "Statistieken (weergaven en gesprekken) zijn in deze omgeving nog niet beschikbaar.",
      "views_one": "{{count}} weergave",
      "views_other": "{{count}} weergaven",
      "conversations_one": "{{count}} gesprek",
      "conversations_other": "{{count}} gesprekken",
      "messages_one": "{{count}} bericht",
      "messages_other": "{{count}} berichten",
      "status": {
        "all": "Alle",
        "available": "Beschikbaar",
        "reserved": "Gereserveerd",
        "sold": "Verkocht"
      }
    },
    "adminModeration": {
      "title": "Inhoud Moderatie",
      "description": "Bekijk en beheer gemelde items",
      "subtitle": "{{count}} item wacht op beoordeling",
      "subtitle_plural": "{{count}} items wachten op beoordeling",
      "loading": "Gemelde items laden...",
      "noReports": "Alles Goed!",
      "noReportsDescription": "Geen items zijn gemeld. Geweldige gemeenschap!",
      "seller": "Verkoper",
      "reports": "Meldingen",
      "reportDetails": "Melding Details",
      "viewItem": "Bekijk Item",
      "approve": "Goedkeuren",
      "delete": "Verwijderen",
      "approveTitle": "Item Goedkeuren",
      "approveMessage": "Weet u zeker dat u \"{{title}}\" wilt goedkeuren? Dit zal alle meldingen resetten.",
      "approveSuccess": "Item succesvol goedgekeurd",
      "deleteTitle": "Item Verwijderen",
      "deleteMessage": "Weet u zeker dat u \"{{title}}\" wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.",
      "deleteSuccess": "Item succesvol verwijderd",
      "reasons": {
        "inappropriate": "Ongepaste inhoud",
        "scam": "Vermoedelijke oplichting",
        "copyright": "Auteursrecht probleem",
        "other": "Overig"
      },
      "tabs": {
        "items": "Gemelde Items",
        "disputes": "Transactie Geschillen"
      },
      "disputes": {
        "subtitle": "{{count}} geschil wacht op oplossing",
        "subtitle_plural": "{{count}} geschillen wachten op oplossing",
        "noDisputes": "Geen Geschillen!",
        "noDisputesDescription": "Geen transactie geschillen op dit moment.",
        "disputed": "Geschil",
        "disputeDetails": "Geschil Details",
        "buyer": "Koper",
        "seller": "Verkoper",
        "unknownItem": "Onbekend Item",
        "reportedOn": "Gemeld op",
        "viewChat": "Bekijk Chat",
        "approvePayment": "Betaling Goedkeuren",
        "issueRefund": "Terugbetaling Doen",
        "approveTitle": "Betaling Goedkeuren",
        "approveMessage": "Weet u zeker dat u de betaling voor \"{{title}}\" wilt goedkeuren? Dit zal het geld naar de verkoper overmaken.",
        "approveSuccess": "Betaling succesvol goedgekeurd",
        "refundTitle": "Terugbetaling Doen",
        "refundMessage": "Weet u zeker dat u \"{{title}}\" wilt terugbetalen? Dit zal het geld naar de koper terugstorten.",
        "refundSuccess": "Terugbetaling succesvol gedaan",
        "reasons": {
          "mismatch": "Item komt niet overeen met beschrijving",
          "noShow": "Verkoper is niet verschenen bij afspraak",
          "damaged": "Item beschadigd of kapot",
          "other": "Overig"
        }
      }
    },
    "adminOptionLists": {
      "title": "Opties Beheren",
      "tabs": {
        "category": "Categorie",
        "condition": "Conditie",
        "size": "Maat",
        "sportType": "Sporttype"
      },
      "addOption": "+ Optie Toevoegen",
      "viewCustomValues": "Aangepaste Waarden Bekijken",
      "form": {
        "editTitle": "Optie Bewerken",
        "addTitle": "Nieuwe Optie Toevoegen",
        "value": "Interne Waarde",
        "labelEn": "Engels Label",
        "labelNl": "Nederlands Label",
        "sortOrder": "Sorteervolgorde",
        "active": "Actief",
        "allFieldsRequired": "Vul alle verplichte velden in",
        "saveSuccess": "Optie succesvol opgeslagen"
      },
      "delete": {
        "title": "Optie Verwijderen",
        "message": "Weet je zeker dat je \"{{value}}\" wilt verwijderen? Dit zal het deactiveren.",
        "success": "Optie succesvol verwijderd"
      }
    },
    "adminCustomValues": {
      "title": "Aangepaste Waarden",
      "noCustomValues": "Geen aangepaste waarden in behandeling",
      "usedTimes": "{{count}} keer gebruikt",
      "firstUsed": "Eerst gebruikt",
      "promote": {
        "button": "Promoveren",
        "title": "\"{{value}}\" Promoveren",
        "similarFound": "Vergelijkbare waarden gevonden (selecteer om samen te voegen):",
        "totalUsage": "Totaal gebruik: {{count}} keer",
        "confirmTitle": "Promotie Bevestigen",
        "confirmMessage": "Dit maakt een officiële optie aan en werkt alle items bij die deze {{count}} waarde(n) gebruiken.",
        "confirmButton": "Promoveer naar Officieel",
        "success": "Succesvol gepromoveerd! {{count}} items bijgewerkt."
      },
      "form": {
        "translationsRequired": "Geef zowel een Engels als Nederlands label op"
      }
    },
    "adminPayouts": {
      "title": "Uitbetalingen",
      "dashboardDescription": "Beheer uitbetalingen aan verkopers en clubs",
      "tabs": {
        "sellers": "Verkopers",
        "clubs": "Clubs"
      },
      "filters": {
        "all": "Alles",
        "pending": "In afwachting",
        "paid": "Betaald",
        "failed": "Mislukt"
      },
      "seller": {
        "emptyState": "Geen uitbetalingen aan verkopers gevonden",
        "amount": "Bedrag",
        "status": "Status",
        "iban": "IBAN",
        "accountHolder": "Rekeninghouder",
        "item": "Item",
        "mollieId": "Mollie ID",
        "markPaid": "Markeren als Betaald",
        "markFailed": "Markeren als Mislukt",
        "updateIban": "IBAN Bijwerken",
        "reference": "Bankreferentie",
        "referencePlaceholder": "bijv. Overboeking 12345",
        "failureReason": "Reden van mislukking",
        "failureReasonPlaceholder": "bijv. Ongeldig IBAN",
        "updateIbanTitle": "Bankgegevens Bijwerken",
        "ibanLabel": "IBAN",
        "accountHolderLabel": "Naam rekeninghouder",
        "accountHolderPlaceholder": "Naam op bankrekening",
        "ibanPlaceholder": "NL00 BANK 0000 0000 00"
      },
      "club": {
        "emptyState": "Geen clubs met openstaande uitbetalingen",
        "pendingAmount": "Openstaand bedrag",
        "transactions": "transacties",
        "createPayout": "Uitbetaling Aanmaken",
        "confirmCreate": "Uitbetaling van {{amount}} aanmaken voor {{count}} transacties?",
        "pastPayouts": "Eerdere Uitbetalingen"
      },
      "status": {
        "pending": "In afwachting",
        "paid": "Betaald",
        "failed": "Mislukt"
      }
    },
    "adminTransactions": {
      "title": "Openstaande transacties",
      "dashboardDescription": "Bekijk en beheer openstaande transacties",
      "subtitle": "{{count}} openstaande transacties",
      "cancel": "Annuleren",
      "reset": "Resetten",
      "cancelConfirm": "Weet je zeker dat je deze transactie wilt annuleren?",
      "resetConfirm": "Weet je zeker dat je deze transactie wilt resetten naar 'in afwachting'?",
      "empty": "Geen openstaande transacties",
      "itemDeleted": "(item verwijderd)",
      "lessThanDay": "< 1 dag",
      "daysAgo_one": "{{count}} dag",
      "daysAgo_other": "{{count}} dagen",
      "useRefund": "Gebruik terugbetaling om een betaalde transactie terug te draaien",
      "status": {
        "pending": "In Behandeling",
        "buyer_confirmed": "Overschrijving Verstuurd",
        "paid": "Betaald",
        "completed": "Voltooid",
        "disputed": "Geschil",
        "cancelled": "Geannuleerd",
        "refunded": "Terugbetaald",
        "failed": "Mislukt"
      }
    },
    "deleteAccount": {
      "title": "Account verwijderen",
      "profileButton": "Account verwijderen",
      "step1Title": "Wat wordt er verwijderd?",
      "step1Subtitle": "Dit kan niet ongedaan worden gemaakt.",
      "impactListings": "actieve advertentie(s) worden verwijderd",
      "impactTransactions": "lopende transactie(s) worden geannuleerd",
      "impactClubs": "club(s) hebben een nieuwe beheerder nodig",
      "impactMessages": "Je berichten worden geanonimiseerd",
      "impactData": "Financiële gegevens blijven bewaard voor de administratie",
      "continueButton": "Ik begrijp dit, ga verder",
      "step2Title": "Club overdracht vereist",
      "step2Subtitle": "Je bent de enige beheerder van onderstaande club(s). Kies een nieuw lid als beheerder voordat je verdergaat.",
      "step2AllRequired": "Kies voor elke club een nieuwe beheerder.",
      "step2Continue": "Overdracht bevestigen, ga verder",
      "selectNewManager": "Kies nieuwe beheerder",
      "noMembers": "Geen andere leden beschikbaar",
      "step3Title": "Definitieve bevestiging",
      "step3Subtitle": "Typ je e-mailadres om te bevestigen dat je je account permanent wilt verwijderen.",
      "emailLabel": "E-mailadres ter bevestiging",
      "checkboxLabel": "Ik begrijp dat mijn account permanent wordt verwijderd en dit niet ongedaan gemaakt kan worden.",
      "finalButton": "Verwijder mijn account definitief",
      "deleting": "Account verwijderen...",
      "errorTitle": "Verwijderen mislukt",
      "emailMismatch": "E-mailadres komt niet overeen met je account."
    },
    "clubLeaderboard": {
      "title": "Ranglijst",
      "subtitle": "De meest actieve clubs op Clubswap — op leden en actuele advertenties.",
      "members": "leden",
      "listings": "advertenties",
      "noClubs": "Nog geen clubs",
      "noClubsSubtext": "Clubs verschijnen hier zodra ze leden hebben.",
      "loadError": "Ranglijst laden mislukt"
    }
  },
  "components": {
    "clubLogoUploader": {
      "title": "Clublogo",
      "addLogo": "Logo toevoegen",
      "changeLogo": "Logo wijzigen",
      "removeLogo": "Logo verwijderen",
      "uploading": "Logo uploaden..."
    },
    "comboSelect": {
      "addCustom": "Voeg \"{{value}}\" toe",
      "searchPlaceholder": "Zoek {{type}}...",
      "listTypes": {
        "category": "categorieën",
        "condition": "condities",
        "size": "maten",
        "sport_type": "sporten"
      },
      "custom": "Eigen"
    },
    "imageUploader": {
      "title": "Productfoto’s",
      "hint": "De eerste foto is de omslag. Max 2 foto’s.",
      "uploading": "Uploaden...",
      "addPhoto": "Foto toevoegen",
      "imagesCount": "{{current}}/{{max}} afbeeldingen"
    },
    "itemCard": {
      "price": "€{{amount}}",
      "size": "Maat",
      "club": "Club",
      "noImage": "Geen afbeelding",
      "viewCount_one": "{{count}} kijker",
      "viewCount_other": "{{count}} kijkers",
      "views_one": "{{count}} weergave",
      "views_other": "{{count}} weergaven"
    },
    "welcomeHero": {
      "welcomeBack": "Welkom terug,",
      "guest": "Gast",
      "items": "items",
      "new": "nieuw",
      "last24h": "Laatste 24u",
      "clubs": "clubs",
      "searchPlaceholder": "Zoek uitrusting…",
      "browseAll": "Bekijk aanbod",
      "newToday": "nieuw vandaag"
    },
    "clubFilter": {
      "allClubs": "Alle clubs",
      "filterByClub": "Filter op club",
      "unknownClub": "Onbekende club"
    },
    "emptyStateNoClubs": {
      "title": "Word lid van een club om te ruilen",
      "subtitle": "Clubswap toont het aanbod van de clubs waar je lid van bent.",
      "button": "Bekijk clubs"
    },
    "sectionHeader": {
      "count_one": "{{count}} artikel",
      "count_other": "{{count}} artikelen"
    }
  },
  "navigation": {
    "home": "Home",
    "browse": "Aanbod",
    "clubs": "Clubs",
    "profile": "Profiel",
    "conversations": "Berichten",
    "loading": "Laden...",
    "login": "Inloggen",
    "register": "Account aanmaken",
    "addListing": "Advertentie plaatsen",
    "signUp": "Registreren"
  },
  "dialogs": {}
}
